'use client';

import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import moment from 'moment';
import type { ReactNode } from 'react';
import { useToggle } from 'react-use';
import { Collapse } from 'transitions-kit';
import { getENV, useSitePreviewData } from '@libs/common-next';
import { dateToAz } from '../preview/configuration/date-picker/utils';
import css from './fold.module.scss';
type Props = {
  children: ReactNode;
};
export function Fold(t0) {
  const $ = _c(24);
  const {
    children
  } = t0;
  const [open, toggle] = useToggle(false);
  const previewData = useSitePreviewData();
  const previewMode = previewData?.contentfulPreviewMode ?? false;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getENV("NEXT_PUBLIC_EPHEMERAL");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const ephemeral = t1;
  let t2;
  if ($[1] !== previewData) {
    t2 = previewData ? moment(dateToAz(previewData.previewDate ?? new Date().toISOString())).format("MMM D, HH:mm") : null;
    $[1] = previewData;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const formattedDate = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("devtools", css.devtool);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children) {
    t4 = <div className={css.content}>{children}</div>;
    $[4] = children;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== open || $[7] !== t4) {
    t5 = <Collapse in={open} mountOnEnter={true} unmountOnExit={true}>{t4}</Collapse>;
    $[6] = open;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = !!formattedDate;
  let t7;
  if ($[9] !== open || $[10] !== t6) {
    t7 = cn(css.icon, {
      [css.open]: open,
      [css.pill]: t6
    });
    $[9] = open;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className={css.gear}>⚙︎</span>;
    t9 = ephemeral && <span className={css.env}>{ephemeral}</span>;
    $[12] = t8;
    $[13] = t9;
  } else {
    t8 = $[12];
    t9 = $[13];
  }
  let t10;
  if ($[14] !== formattedDate || $[15] !== previewMode) {
    t10 = formattedDate && <span className={css.previewInfo}><span className={css.date}>{formattedDate}</span><span className={previewMode ? css.draft : css.published}><span className={css.dot} />{previewMode ? "Preview" : "Delivery"}</span></span>;
    $[14] = formattedDate;
    $[15] = previewMode;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t7 || $[19] !== toggle) {
    t11 = <button type="button" className={t7} onClick={toggle}>{t8}{t9}{t10}</button>;
    $[17] = t10;
    $[18] = t7;
    $[19] = toggle;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t5) {
    t12 = <div className={t3}><div className={css.surface}>{t5}{t11}</div></div>;
    $[21] = t11;
    $[22] = t5;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
}